import { NgModule } from '@angular/core';
import { NgcCookieConsentModule } from 'ngx-cookieconsent';
import { COOKIE_CONSENT_CONFIG } from './cookie-consent.config';

@NgModule({
  imports: [NgcCookieConsentModule.forRoot(COOKIE_CONSENT_CONFIG)],
  exports: [NgcCookieConsentModule]
})
export class CookieConsentModule {}
